import classNames from "classnames"
import { FC } from "react"

// components
import { Footer } from "./Footer"
import FooterCopyright from "./FooterCopyright"
import { RegionSelector } from "../RegionSelector/RegionSelector"

// utils
import { events } from "../../utils/heap/tracking_events"

// styles
import { edsGCell } from "../../theme/global.module.scss"
import * as globalStyles from "../../theme/global.module.scss"
import {
  allRightsReserved,
  footerSectionBorder,
  footerBaseUl,
  footerBaseSection,
  footerBaseLinkSection
} from "./Footer.module.scss"

export type FooterNavCopy = NonNullable<
  Queries.HomepageDataQuery["contentfulFooterNavigation"]
>["FooterNavigationChildItems"]

type Props = {
  footerNavCopy: FooterNavCopy
}
export const FooterBase: FC<Props> = ({ footerNavCopy }) => {
  return (
    <>
      <div
        className={classNames(
          allRightsReserved,
          // @ts-expect-error typed-scss-modules generates `edsLMarTop_4`; webpack css-loader exports `edsLMarTop4`. See README "Stylesheets".
          globalStyles.edsLMarTop4
        )}
      >
        <div>
          <div className={footerSectionBorder}></div>
        </div>
        <div
          className={classNames(
            footerBaseSection,
            edsGCell,
            // @ts-expect-error typed-scss-modules generates `edsLPadVert_4`; webpack css-loader exports `edsLPadVert4`. See README "Stylesheets".
            globalStyles.edsLPadVert4
          )}
          id="footer-copyright"
        >
          <ul className={footerBaseUl}>
            <li>
              <FooterCopyright />
            </li>
            <li>
              <div className={footerBaseLinkSection}>
                {footerNavCopy?.map((footerBaseLink, index) => {
                  if (!footerBaseLink) return null

                  const isManageCookieLink =
                    footerBaseLink.footerNavigationInternalTitle?.toLowerCase() ===
                    "link: manage cookie preferences"
                  const linkBullet =
                    index === footerNavCopy.length - 1
                      ? ""
                      : classNames(
                          // @ts-expect-error typed-scss-modules generates `edsGlobalFooterLinkBullet`; webpack css-loader exports `edsGlobalFooter__linkBullet`. See README "Stylesheets".
                          globalStyles.edsGlobalFooter__linkBullet
                        )
                  const navUrl = footerBaseLink.footerNavigationUrl ?? ""

                  return (
                    <a
                      key={`${footerBaseLink}__${index}`}
                      href={isManageCookieLink ? "#" : navUrl}
                      target="_blank"
                      onClick={(e) => {
                        e.preventDefault()

                        events?.footerLinkClick(
                          `${footerBaseLink.displayText} - ${encodeURI(navUrl)}`,
                          Footer?.name
                        )

                        if (typeof window !== "undefined") {
                          if (isManageCookieLink) {
                            window?.transcend?.showConsentManager?.({
                              viewState: "CompleteOptions"
                            })
                          } else {
                            window.open(navUrl, "_newtab")
                          }
                        }
                      }}
                      className={linkBullet}
                    >
                      {footerBaseLink.displayText}
                    </a>
                  )
                })}
              </div>
            </li>
            <li>
              <div>
                <RegionSelector />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className={footerSectionBorder}></div>
    </>
  )
}
